module.exports = __webpack_public_path__ + "static/media/ProximaNova-Extrabld.51563919.ttf";